// source: user.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var enum_pb = require('./enum_pb.js');

goog.object.extend(proto, enum_pb);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.manabie.bob.BasicProfile', null, global);
goog.exportSymbol('proto.manabie.bob.ClaimsUserAuthRequest', null, global);
goog.exportSymbol('proto.manabie.bob.ClaimsUserAuthResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetBasicProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetBasicProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetCoachProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetCoachProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetCoachProfilesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetCoachProfilesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetCurrentUserProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetCurrentUserProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetTeacherProfilesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetTeacherProfilesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetTutorProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetTutorProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.TeacherProfile', null, global);
goog.exportSymbol('proto.manabie.bob.TutorProfile', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateTutorStatusRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateTutorStatusResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateUserDeviceTokenRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateUserDeviceTokenResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateUserProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateUserProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UserProfile', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.manabie.bob.UpdateUserDeviceTokenRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateUserDeviceTokenRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateUserDeviceTokenRequest.displayName = 'proto.manabie.bob.UpdateUserDeviceTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateUserDeviceTokenResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateUserDeviceTokenResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateUserDeviceTokenResponse.displayName = 'proto.manabie.bob.UpdateUserDeviceTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UserProfile = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UserProfile, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UserProfile.displayName = 'proto.manabie.bob.UserProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.TutorProfile = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.TutorProfile.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.TutorProfile, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.TutorProfile.displayName = 'proto.manabie.bob.TutorProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetCoachProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetCoachProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetCoachProfileResponse.displayName = 'proto.manabie.bob.GetCoachProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetCoachProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetCoachProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetCoachProfileRequest.displayName = 'proto.manabie.bob.GetCoachProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateUserProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateUserProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateUserProfileRequest.displayName = 'proto.manabie.bob.UpdateUserProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateUserProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateUserProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateUserProfileResponse.displayName = 'proto.manabie.bob.UpdateUserProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateTutorStatusRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateTutorStatusRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateTutorStatusRequest.displayName = 'proto.manabie.bob.UpdateTutorStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateTutorStatusResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateTutorStatusResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateTutorStatusResponse.displayName = 'proto.manabie.bob.UpdateTutorStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetCurrentUserProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetCurrentUserProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetCurrentUserProfileRequest.displayName = 'proto.manabie.bob.GetCurrentUserProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetCurrentUserProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetCurrentUserProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetCurrentUserProfileResponse.displayName = 'proto.manabie.bob.GetCurrentUserProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetTutorProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetTutorProfileRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetTutorProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetTutorProfileRequest.displayName = 'proto.manabie.bob.GetTutorProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetTutorProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetTutorProfileResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetTutorProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetTutorProfileResponse.displayName = 'proto.manabie.bob.GetTutorProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ClaimsUserAuthRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ClaimsUserAuthRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ClaimsUserAuthRequest.displayName = 'proto.manabie.bob.ClaimsUserAuthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ClaimsUserAuthResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ClaimsUserAuthResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ClaimsUserAuthResponse.displayName = 'proto.manabie.bob.ClaimsUserAuthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetCoachProfilesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetCoachProfilesRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetCoachProfilesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetCoachProfilesRequest.displayName = 'proto.manabie.bob.GetCoachProfilesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetCoachProfilesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetCoachProfilesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetCoachProfilesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetCoachProfilesResponse.displayName = 'proto.manabie.bob.GetCoachProfilesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.TeacherProfile = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.TeacherProfile.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.TeacherProfile, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.TeacherProfile.displayName = 'proto.manabie.bob.TeacherProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetTeacherProfilesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetTeacherProfilesRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetTeacherProfilesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetTeacherProfilesRequest.displayName = 'proto.manabie.bob.GetTeacherProfilesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetTeacherProfilesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetTeacherProfilesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetTeacherProfilesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetTeacherProfilesResponse.displayName = 'proto.manabie.bob.GetTeacherProfilesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.BasicProfile = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.BasicProfile, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.BasicProfile.displayName = 'proto.manabie.bob.BasicProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetBasicProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetBasicProfileRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetBasicProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetBasicProfileRequest.displayName = 'proto.manabie.bob.GetBasicProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetBasicProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetBasicProfileResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetBasicProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetBasicProfileResponse.displayName = 'proto.manabie.bob.GetBasicProfileResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateUserDeviceTokenRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateUserDeviceTokenRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateUserDeviceTokenRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      deviceToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
      allowNotification: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateUserDeviceTokenRequest}
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateUserDeviceTokenRequest();
  return proto.manabie.bob.UpdateUserDeviceTokenRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateUserDeviceTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateUserDeviceTokenRequest}
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUserId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDeviceToken(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setAllowNotification(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateUserDeviceTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateUserDeviceTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getDeviceToken();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getAllowNotification();

  if (f) {
    writer.writeBool(3, f);
  }
};
/**
 * optional string user_id = 1;
 * @return {string}
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.getUserId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.setUserId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string device_token = 2;
 * @return {string}
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.getDeviceToken = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.setDeviceToken = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional bool allow_notification = 3;
 * @return {boolean}
 */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.getAllowNotification = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpdateUserDeviceTokenRequest.prototype.setAllowNotification = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateUserDeviceTokenResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateUserDeviceTokenResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateUserDeviceTokenResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateUserDeviceTokenResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateUserDeviceTokenResponse}
 */


proto.manabie.bob.UpdateUserDeviceTokenResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateUserDeviceTokenResponse();
  return proto.manabie.bob.UpdateUserDeviceTokenResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateUserDeviceTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateUserDeviceTokenResponse}
 */


proto.manabie.bob.UpdateUserDeviceTokenResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateUserDeviceTokenResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateUserDeviceTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateUserDeviceTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateUserDeviceTokenResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpdateUserDeviceTokenResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpdateUserDeviceTokenResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UserProfile.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UserProfile.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UserProfile} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UserProfile.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
      email: jspb.Message.getFieldWithDefault(msg, 5, ""),
      avatar: jspb.Message.getFieldWithDefault(msg, 6, ""),
      deviceToken: jspb.Message.getFieldWithDefault(msg, 7, ""),
      userGroup: jspb.Message.getFieldWithDefault(msg, 8, ""),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UserProfile}
 */


proto.manabie.bob.UserProfile.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UserProfile();
  return proto.manabie.bob.UserProfile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UserProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UserProfile}
 */


proto.manabie.bob.UserProfile.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPhoneNumber(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmail(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAvatar(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDeviceToken(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUserGroup(value);
        break;

      case 9:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 10:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UserProfile.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UserProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UserProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UserProfile.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getPhoneNumber();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getEmail();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getAvatar();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getDeviceToken();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getUserGroup();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(9, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(10, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.UserProfile.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.UserProfile.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string phone_number = 4;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getPhoneNumber = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setPhoneNumber = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string email = 5;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getEmail = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setEmail = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string avatar = 6;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getAvatar = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setAvatar = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string device_token = 7;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getDeviceToken = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setDeviceToken = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string user_group = 8;
 * @return {string}
 */


proto.manabie.bob.UserProfile.prototype.getUserGroup = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UserProfile.prototype.setUserGroup = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.UserProfile.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.UserProfile.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UserProfile.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UserProfile.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 9) != null;
};
/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.UserProfile.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.UserProfile.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UserProfile.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UserProfile.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 10) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.TutorProfile.repeatedFields_ = [9];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.TutorProfile.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.TutorProfile.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.TutorProfile} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.TutorProfile.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
      email: jspb.Message.getFieldWithDefault(msg, 5, ""),
      avatar: jspb.Message.getFieldWithDefault(msg, 6, ""),
      deviceToken: jspb.Message.getFieldWithDefault(msg, 7, ""),
      userGroup: jspb.Message.getFieldWithDefault(msg, 8, ""),
      skillSetList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
      status: jspb.Message.getFieldWithDefault(msg, 10, 0),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.TutorProfile}
 */


proto.manabie.bob.TutorProfile.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.TutorProfile();
  return proto.manabie.bob.TutorProfile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.TutorProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.TutorProfile}
 */


proto.manabie.bob.TutorProfile.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPhoneNumber(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmail(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAvatar(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDeviceToken(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUserGroup(value);
        break;

      case 9:
        var value =
        /** @type {!Array<!proto.manabie.bob.Subject>} */
        reader.readPackedEnum();
        msg.setSkillSetList(value);
        break;

      case 10:
        var value =
        /** @type {!proto.manabie.bob.TutorStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      case 11:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 12:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.TutorProfile.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.TutorProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.TutorProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.TutorProfile.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getPhoneNumber();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getEmail();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getAvatar();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getDeviceToken();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getUserGroup();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getSkillSetList();

  if (f.length > 0) {
    writer.writePackedEnum(9, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(10, f);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(11, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(12, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.TutorProfile.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.TutorProfile.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string phone_number = 4;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getPhoneNumber = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setPhoneNumber = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string email = 5;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getEmail = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setEmail = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string avatar = 6;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getAvatar = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setAvatar = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string device_token = 7;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getDeviceToken = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setDeviceToken = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string user_group = 8;
 * @return {string}
 */


proto.manabie.bob.TutorProfile.prototype.getUserGroup = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TutorProfile.prototype.setUserGroup = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * repeated Subject skill_set = 9;
 * @return {!Array<!proto.manabie.bob.Subject>}
 */


proto.manabie.bob.TutorProfile.prototype.getSkillSetList = function () {
  return (
    /** @type {!Array<!proto.manabie.bob.Subject>} */
    jspb.Message.getRepeatedField(this, 9)
  );
};
/** @param {!Array<!proto.manabie.bob.Subject>} value */


proto.manabie.bob.TutorProfile.prototype.setSkillSetList = function (value) {
  jspb.Message.setField(this, 9, value || []);
};
/**
 * @param {!proto.manabie.bob.Subject} value
 * @param {number=} opt_index
 */


proto.manabie.bob.TutorProfile.prototype.addSkillSet = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.TutorProfile.prototype.clearSkillSetList = function () {
  this.setSkillSetList([]);
};
/**
 * optional TutorStatus status = 10;
 * @return {!proto.manabie.bob.TutorStatus}
 */


proto.manabie.bob.TutorProfile.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.TutorStatus} */
    jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};
/** @param {!proto.manabie.bob.TutorStatus} value */


proto.manabie.bob.TutorProfile.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};
/**
 * optional google.protobuf.Timestamp created_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.TutorProfile.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.TutorProfile.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 11, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TutorProfile.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TutorProfile.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 11) != null;
};
/**
 * optional google.protobuf.Timestamp updated_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.TutorProfile.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.TutorProfile.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 12, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TutorProfile.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TutorProfile.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 12) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetCoachProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetCoachProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetCoachProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetCoachProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profile: (f = msg.getProfile()) && proto.manabie.bob.UserProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetCoachProfileResponse}
 */


proto.manabie.bob.GetCoachProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetCoachProfileResponse();
  return proto.manabie.bob.GetCoachProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetCoachProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetCoachProfileResponse}
 */


proto.manabie.bob.GetCoachProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.UserProfile();
        reader.readMessage(value, proto.manabie.bob.UserProfile.deserializeBinaryFromReader);
        msg.setProfile(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetCoachProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetCoachProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetCoachProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetCoachProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfile();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.UserProfile.serializeBinaryToWriter);
  }
};
/**
 * optional UserProfile profile = 1;
 * @return {?proto.manabie.bob.UserProfile}
 */


proto.manabie.bob.GetCoachProfileResponse.prototype.getProfile = function () {
  return (
    /** @type{?proto.manabie.bob.UserProfile} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.UserProfile, 1)
  );
};
/** @param {?proto.manabie.bob.UserProfile|undefined} value */


proto.manabie.bob.GetCoachProfileResponse.prototype.setProfile = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.GetCoachProfileResponse.prototype.clearProfile = function () {
  this.setProfile(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.GetCoachProfileResponse.prototype.hasProfile = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetCoachProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetCoachProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetCoachProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetCoachProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profileId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetCoachProfileRequest}
 */


proto.manabie.bob.GetCoachProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetCoachProfileRequest();
  return proto.manabie.bob.GetCoachProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetCoachProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetCoachProfileRequest}
 */


proto.manabie.bob.GetCoachProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setProfileId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetCoachProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetCoachProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetCoachProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetCoachProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfileId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string profile_id = 1;
 * @return {string}
 */


proto.manabie.bob.GetCoachProfileRequest.prototype.getProfileId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetCoachProfileRequest.prototype.setProfileId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateUserProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateUserProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateUserProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateUserProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profile: (f = msg.getProfile()) && proto.manabie.bob.UserProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateUserProfileRequest}
 */


proto.manabie.bob.UpdateUserProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateUserProfileRequest();
  return proto.manabie.bob.UpdateUserProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateUserProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateUserProfileRequest}
 */


proto.manabie.bob.UpdateUserProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.UserProfile();
        reader.readMessage(value, proto.manabie.bob.UserProfile.deserializeBinaryFromReader);
        msg.setProfile(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateUserProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateUserProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateUserProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateUserProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfile();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.UserProfile.serializeBinaryToWriter);
  }
};
/**
 * optional UserProfile profile = 1;
 * @return {?proto.manabie.bob.UserProfile}
 */


proto.manabie.bob.UpdateUserProfileRequest.prototype.getProfile = function () {
  return (
    /** @type{?proto.manabie.bob.UserProfile} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.UserProfile, 1)
  );
};
/** @param {?proto.manabie.bob.UserProfile|undefined} value */


proto.manabie.bob.UpdateUserProfileRequest.prototype.setProfile = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UpdateUserProfileRequest.prototype.clearProfile = function () {
  this.setProfile(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UpdateUserProfileRequest.prototype.hasProfile = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateUserProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateUserProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateUserProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateUserProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateUserProfileResponse}
 */


proto.manabie.bob.UpdateUserProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateUserProfileResponse();
  return proto.manabie.bob.UpdateUserProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateUserProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateUserProfileResponse}
 */


proto.manabie.bob.UpdateUserProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateUserProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateUserProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateUserProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateUserProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpdateUserProfileResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpdateUserProfileResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateTutorStatusRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateTutorStatusRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateTutorStatusRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateTutorStatusRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      status: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateTutorStatusRequest}
 */


proto.manabie.bob.UpdateTutorStatusRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateTutorStatusRequest();
  return proto.manabie.bob.UpdateTutorStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateTutorStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateTutorStatusRequest}
 */


proto.manabie.bob.UpdateTutorStatusRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.TutorStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateTutorStatusRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateTutorStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateTutorStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateTutorStatusRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
};
/**
 * optional TutorStatus status = 1;
 * @return {!proto.manabie.bob.TutorStatus}
 */


proto.manabie.bob.UpdateTutorStatusRequest.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.TutorStatus} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.TutorStatus} value */


proto.manabie.bob.UpdateTutorStatusRequest.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateTutorStatusResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateTutorStatusResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateTutorStatusResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateTutorStatusResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateTutorStatusResponse}
 */


proto.manabie.bob.UpdateTutorStatusResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateTutorStatusResponse();
  return proto.manabie.bob.UpdateTutorStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateTutorStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateTutorStatusResponse}
 */


proto.manabie.bob.UpdateTutorStatusResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateTutorStatusResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateTutorStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateTutorStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateTutorStatusResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetCurrentUserProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetCurrentUserProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetCurrentUserProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetCurrentUserProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetCurrentUserProfileRequest}
 */


proto.manabie.bob.GetCurrentUserProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetCurrentUserProfileRequest();
  return proto.manabie.bob.GetCurrentUserProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetCurrentUserProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetCurrentUserProfileRequest}
 */


proto.manabie.bob.GetCurrentUserProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetCurrentUserProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetCurrentUserProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetCurrentUserProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetCurrentUserProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetCurrentUserProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetCurrentUserProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetCurrentUserProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetCurrentUserProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profile: (f = msg.getProfile()) && proto.manabie.bob.UserProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetCurrentUserProfileResponse}
 */


proto.manabie.bob.GetCurrentUserProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetCurrentUserProfileResponse();
  return proto.manabie.bob.GetCurrentUserProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetCurrentUserProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetCurrentUserProfileResponse}
 */


proto.manabie.bob.GetCurrentUserProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.UserProfile();
        reader.readMessage(value, proto.manabie.bob.UserProfile.deserializeBinaryFromReader);
        msg.setProfile(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetCurrentUserProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetCurrentUserProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetCurrentUserProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetCurrentUserProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfile();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.UserProfile.serializeBinaryToWriter);
  }
};
/**
 * optional UserProfile profile = 1;
 * @return {?proto.manabie.bob.UserProfile}
 */


proto.manabie.bob.GetCurrentUserProfileResponse.prototype.getProfile = function () {
  return (
    /** @type{?proto.manabie.bob.UserProfile} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.UserProfile, 1)
  );
};
/** @param {?proto.manabie.bob.UserProfile|undefined} value */


proto.manabie.bob.GetCurrentUserProfileResponse.prototype.setProfile = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.GetCurrentUserProfileResponse.prototype.clearProfile = function () {
  this.setProfile(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.GetCurrentUserProfileResponse.prototype.hasProfile = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetTutorProfileRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetTutorProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetTutorProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetTutorProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetTutorProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profileIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetTutorProfileRequest}
 */


proto.manabie.bob.GetTutorProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetTutorProfileRequest();
  return proto.manabie.bob.GetTutorProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetTutorProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetTutorProfileRequest}
 */


proto.manabie.bob.GetTutorProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addProfileIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetTutorProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetTutorProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetTutorProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetTutorProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfileIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string profile_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.GetTutorProfileRequest.prototype.getProfileIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.GetTutorProfileRequest.prototype.setProfileIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.GetTutorProfileRequest.prototype.addProfileIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetTutorProfileRequest.prototype.clearProfileIdsList = function () {
  this.setProfileIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetTutorProfileResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetTutorProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetTutorProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetTutorProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetTutorProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profilesList: jspb.Message.toObjectList(msg.getProfilesList(), proto.manabie.bob.TutorProfile.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetTutorProfileResponse}
 */


proto.manabie.bob.GetTutorProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetTutorProfileResponse();
  return proto.manabie.bob.GetTutorProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetTutorProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetTutorProfileResponse}
 */


proto.manabie.bob.GetTutorProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.TutorProfile();
        reader.readMessage(value, proto.manabie.bob.TutorProfile.deserializeBinaryFromReader);
        msg.addProfiles(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetTutorProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetTutorProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetTutorProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetTutorProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfilesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.TutorProfile.serializeBinaryToWriter);
  }
};
/**
 * repeated TutorProfile profiles = 1;
 * @return {!Array<!proto.manabie.bob.TutorProfile>}
 */


proto.manabie.bob.GetTutorProfileResponse.prototype.getProfilesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.TutorProfile>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.TutorProfile, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.TutorProfile>} value */


proto.manabie.bob.GetTutorProfileResponse.prototype.setProfilesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.TutorProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.TutorProfile}
 */


proto.manabie.bob.GetTutorProfileResponse.prototype.addProfiles = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.TutorProfile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetTutorProfileResponse.prototype.clearProfilesList = function () {
  this.setProfilesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ClaimsUserAuthRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ClaimsUserAuthRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ClaimsUserAuthRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ClaimsUserAuthRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ClaimsUserAuthRequest}
 */


proto.manabie.bob.ClaimsUserAuthRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ClaimsUserAuthRequest();
  return proto.manabie.bob.ClaimsUserAuthRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ClaimsUserAuthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ClaimsUserAuthRequest}
 */


proto.manabie.bob.ClaimsUserAuthRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ClaimsUserAuthRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ClaimsUserAuthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ClaimsUserAuthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ClaimsUserAuthRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ClaimsUserAuthResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ClaimsUserAuthResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ClaimsUserAuthResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ClaimsUserAuthResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ClaimsUserAuthResponse}
 */


proto.manabie.bob.ClaimsUserAuthResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ClaimsUserAuthResponse();
  return proto.manabie.bob.ClaimsUserAuthResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ClaimsUserAuthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ClaimsUserAuthResponse}
 */


proto.manabie.bob.ClaimsUserAuthResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ClaimsUserAuthResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ClaimsUserAuthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ClaimsUserAuthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ClaimsUserAuthResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.ClaimsUserAuthResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.ClaimsUserAuthResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetCoachProfilesRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetCoachProfilesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetCoachProfilesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetCoachProfilesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetCoachProfilesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profileIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetCoachProfilesRequest}
 */


proto.manabie.bob.GetCoachProfilesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetCoachProfilesRequest();
  return proto.manabie.bob.GetCoachProfilesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetCoachProfilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetCoachProfilesRequest}
 */


proto.manabie.bob.GetCoachProfilesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addProfileIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetCoachProfilesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetCoachProfilesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetCoachProfilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetCoachProfilesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfileIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string profile_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.GetCoachProfilesRequest.prototype.getProfileIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.GetCoachProfilesRequest.prototype.setProfileIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.GetCoachProfilesRequest.prototype.addProfileIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetCoachProfilesRequest.prototype.clearProfileIdsList = function () {
  this.setProfileIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetCoachProfilesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetCoachProfilesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetCoachProfilesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetCoachProfilesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetCoachProfilesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profilesList: jspb.Message.toObjectList(msg.getProfilesList(), proto.manabie.bob.UserProfile.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetCoachProfilesResponse}
 */


proto.manabie.bob.GetCoachProfilesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetCoachProfilesResponse();
  return proto.manabie.bob.GetCoachProfilesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetCoachProfilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetCoachProfilesResponse}
 */


proto.manabie.bob.GetCoachProfilesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.UserProfile();
        reader.readMessage(value, proto.manabie.bob.UserProfile.deserializeBinaryFromReader);
        msg.addProfiles(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetCoachProfilesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetCoachProfilesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetCoachProfilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetCoachProfilesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfilesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.UserProfile.serializeBinaryToWriter);
  }
};
/**
 * repeated UserProfile profiles = 1;
 * @return {!Array<!proto.manabie.bob.UserProfile>}
 */


proto.manabie.bob.GetCoachProfilesResponse.prototype.getProfilesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.UserProfile>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.UserProfile, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.UserProfile>} value */


proto.manabie.bob.GetCoachProfilesResponse.prototype.setProfilesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.UserProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.UserProfile}
 */


proto.manabie.bob.GetCoachProfilesResponse.prototype.addProfiles = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.UserProfile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetCoachProfilesResponse.prototype.clearProfilesList = function () {
  this.setProfilesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.TeacherProfile.repeatedFields_ = [9];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.TeacherProfile.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.TeacherProfile.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.TeacherProfile} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.TeacherProfile.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
      email: jspb.Message.getFieldWithDefault(msg, 5, ""),
      avatar: jspb.Message.getFieldWithDefault(msg, 6, ""),
      deviceToken: jspb.Message.getFieldWithDefault(msg, 7, ""),
      userGroup: jspb.Message.getFieldWithDefault(msg, 8, ""),
      schoolIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.TeacherProfile}
 */


proto.manabie.bob.TeacherProfile.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.TeacherProfile();
  return proto.manabie.bob.TeacherProfile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.TeacherProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.TeacherProfile}
 */


proto.manabie.bob.TeacherProfile.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPhoneNumber(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmail(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAvatar(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDeviceToken(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUserGroup(value);
        break;

      case 9:
        var value =
        /** @type {!Array<number>} */
        reader.readPackedInt32();
        msg.setSchoolIdsList(value);
        break;

      case 10:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 11:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.TeacherProfile.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.TeacherProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.TeacherProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.TeacherProfile.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getPhoneNumber();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getEmail();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getAvatar();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getDeviceToken();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getUserGroup();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getSchoolIdsList();

  if (f.length > 0) {
    writer.writePackedInt32(9, f);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(10, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(11, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.TeacherProfile.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.TeacherProfile.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string phone_number = 4;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getPhoneNumber = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setPhoneNumber = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string email = 5;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getEmail = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setEmail = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string avatar = 6;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getAvatar = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setAvatar = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string device_token = 7;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getDeviceToken = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setDeviceToken = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string user_group = 8;
 * @return {string}
 */


proto.manabie.bob.TeacherProfile.prototype.getUserGroup = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TeacherProfile.prototype.setUserGroup = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * repeated int32 school_ids = 9;
 * @return {!Array<number>}
 */


proto.manabie.bob.TeacherProfile.prototype.getSchoolIdsList = function () {
  return (
    /** @type {!Array<number>} */
    jspb.Message.getRepeatedField(this, 9)
  );
};
/** @param {!Array<number>} value */


proto.manabie.bob.TeacherProfile.prototype.setSchoolIdsList = function (value) {
  jspb.Message.setField(this, 9, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 */


proto.manabie.bob.TeacherProfile.prototype.addSchoolIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.TeacherProfile.prototype.clearSchoolIdsList = function () {
  this.setSchoolIdsList([]);
};
/**
 * optional google.protobuf.Timestamp created_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.TeacherProfile.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.TeacherProfile.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TeacherProfile.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TeacherProfile.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 10) != null;
};
/**
 * optional google.protobuf.Timestamp updated_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.TeacherProfile.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.TeacherProfile.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 11, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TeacherProfile.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TeacherProfile.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 11) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetTeacherProfilesRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetTeacherProfilesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetTeacherProfilesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetTeacherProfilesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetTeacherProfilesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetTeacherProfilesRequest}
 */


proto.manabie.bob.GetTeacherProfilesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetTeacherProfilesRequest();
  return proto.manabie.bob.GetTeacherProfilesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetTeacherProfilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetTeacherProfilesRequest}
 */


proto.manabie.bob.GetTeacherProfilesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetTeacherProfilesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetTeacherProfilesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetTeacherProfilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetTeacherProfilesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.GetTeacherProfilesRequest.prototype.getIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.GetTeacherProfilesRequest.prototype.setIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.GetTeacherProfilesRequest.prototype.addIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetTeacherProfilesRequest.prototype.clearIdsList = function () {
  this.setIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetTeacherProfilesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetTeacherProfilesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetTeacherProfilesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetTeacherProfilesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetTeacherProfilesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profilesList: jspb.Message.toObjectList(msg.getProfilesList(), proto.manabie.bob.TeacherProfile.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetTeacherProfilesResponse}
 */


proto.manabie.bob.GetTeacherProfilesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetTeacherProfilesResponse();
  return proto.manabie.bob.GetTeacherProfilesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetTeacherProfilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetTeacherProfilesResponse}
 */


proto.manabie.bob.GetTeacherProfilesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.TeacherProfile();
        reader.readMessage(value, proto.manabie.bob.TeacherProfile.deserializeBinaryFromReader);
        msg.addProfiles(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetTeacherProfilesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetTeacherProfilesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetTeacherProfilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetTeacherProfilesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfilesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.TeacherProfile.serializeBinaryToWriter);
  }
};
/**
 * repeated TeacherProfile profiles = 1;
 * @return {!Array<!proto.manabie.bob.TeacherProfile>}
 */


proto.manabie.bob.GetTeacherProfilesResponse.prototype.getProfilesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.TeacherProfile>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.TeacherProfile, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.TeacherProfile>} value */


proto.manabie.bob.GetTeacherProfilesResponse.prototype.setProfilesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.TeacherProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.TeacherProfile}
 */


proto.manabie.bob.GetTeacherProfilesResponse.prototype.addProfiles = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.TeacherProfile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetTeacherProfilesResponse.prototype.clearProfilesList = function () {
  this.setProfilesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.BasicProfile.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.BasicProfile.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.BasicProfile} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.BasicProfile.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      avatar: jspb.Message.getFieldWithDefault(msg, 3, ""),
      userGroup: jspb.Message.getFieldWithDefault(msg, 4, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.BasicProfile}
 */


proto.manabie.bob.BasicProfile.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.BasicProfile();
  return proto.manabie.bob.BasicProfile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.BasicProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.BasicProfile}
 */


proto.manabie.bob.BasicProfile.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUserId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAvatar(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUserGroup(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.BasicProfile.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.BasicProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.BasicProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.BasicProfile.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getAvatar();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getUserGroup();

  if (f.length > 0) {
    writer.writeString(4, f);
  }
};
/**
 * optional string user_id = 1;
 * @return {string}
 */


proto.manabie.bob.BasicProfile.prototype.getUserId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BasicProfile.prototype.setUserId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.BasicProfile.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BasicProfile.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string avatar = 3;
 * @return {string}
 */


proto.manabie.bob.BasicProfile.prototype.getAvatar = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BasicProfile.prototype.setAvatar = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string user_group = 4;
 * @return {string}
 */


proto.manabie.bob.BasicProfile.prototype.getUserGroup = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BasicProfile.prototype.setUserGroup = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetBasicProfileRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetBasicProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetBasicProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetBasicProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetBasicProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetBasicProfileRequest}
 */


proto.manabie.bob.GetBasicProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetBasicProfileRequest();
  return proto.manabie.bob.GetBasicProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetBasicProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetBasicProfileRequest}
 */


proto.manabie.bob.GetBasicProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addUserIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetBasicProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetBasicProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetBasicProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetBasicProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string user_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.GetBasicProfileRequest.prototype.getUserIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.GetBasicProfileRequest.prototype.setUserIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.GetBasicProfileRequest.prototype.addUserIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetBasicProfileRequest.prototype.clearUserIdsList = function () {
  this.setUserIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetBasicProfileResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetBasicProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetBasicProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetBasicProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetBasicProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profilesList: jspb.Message.toObjectList(msg.getProfilesList(), proto.manabie.bob.BasicProfile.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetBasicProfileResponse}
 */


proto.manabie.bob.GetBasicProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetBasicProfileResponse();
  return proto.manabie.bob.GetBasicProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetBasicProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetBasicProfileResponse}
 */


proto.manabie.bob.GetBasicProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.BasicProfile();
        reader.readMessage(value, proto.manabie.bob.BasicProfile.deserializeBinaryFromReader);
        msg.addProfiles(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetBasicProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetBasicProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetBasicProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetBasicProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfilesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.BasicProfile.serializeBinaryToWriter);
  }
};
/**
 * repeated BasicProfile profiles = 1;
 * @return {!Array<!proto.manabie.bob.BasicProfile>}
 */


proto.manabie.bob.GetBasicProfileResponse.prototype.getProfilesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.BasicProfile>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.BasicProfile, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.BasicProfile>} value */


proto.manabie.bob.GetBasicProfileResponse.prototype.setProfilesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.BasicProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.BasicProfile}
 */


proto.manabie.bob.GetBasicProfileResponse.prototype.addProfiles = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.BasicProfile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetBasicProfileResponse.prototype.clearProfilesList = function () {
  this.setProfilesList([]);
};

goog.object.extend(exports, proto.manabie.bob);